/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ESPSettingsDomains model module.
 * @module model/ESPSettingsDomains
 * @version 1.0.0
 */
export class ESPSettingsDomains {
  /**
   * Constructs a new <code>ESPSettingsDomains</code>.
   * @alias module:model/ESPSettingsDomains
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ESPSettingsDomains</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ESPSettingsDomains} obj Optional instance to populate.
   * @return {module:model/ESPSettingsDomains} The populated <code>ESPSettingsDomains</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ESPSettingsDomains();
      if (data.hasOwnProperty('track'))
        obj.track = ApiClient.convertToType(data['track'], 'String');
      if (data.hasOwnProperty('return'))
        obj.return = ApiClient.convertToType(data['return'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} track
 */
ESPSettingsDomains.prototype.track = undefined;

/**
 * @member {String} return
 */
ESPSettingsDomains.prototype.return = undefined;

